import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import strings from "../i18n/translations";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("spar_theme") || "light");
  const [lang, setLang]   = useState(() => localStorage.getItem("spar_lang")  || "en");

  // Apply theme + direction to <html> whenever they change.
  useEffect(() => {
    const html = document.documentElement;
    html.setAttribute("data-theme", theme);
    html.setAttribute("lang", lang);
    html.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
    localStorage.setItem("spar_theme", theme);
    localStorage.setItem("spar_lang", lang);
  }, [theme, lang]);

  const toggleTheme = useCallback(() =>
    setTheme((t) => (t === "light" ? "dark" : "light")), []);

  const toggleLang = useCallback(() =>
    setLang((l) => (l === "en" ? "ar" : "en")), []);

  const t = useCallback(
    (key) => strings[lang]?.[key] ?? strings.en[key] ?? key,
    [lang]
  );

  return (
    <AppContext.Provider value={{ theme, toggleTheme, lang, toggleLang, t }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
